import { priceFormatter } from '@2wunder/klarx-tool'
import { Col, Row } from 'antd'
import KInfo from 'app/components/Modules/DataDisplay/KInfo'
import Alert from 'app/components/UI-Elements/Feedback/Alert'
import { RecordType } from 'app/constants/GlobalTypes'
import * as React from 'react'
import { useIntl } from 'react-intl'

type Props = {
  invoice?: IInvoice
  complained: boolean
}

const InvoiceDetails: React.FC<Props> = ({ invoice, complained }) => {
  const { formatMessage } = useIntl()
  const { status, invoice_date, amount, due_date, rental_code } = invoice

  return (
    <Row className="fade-in-slow" gutter={[0, 16]}>
      <Col span={24}>
        <KInfo
          recordType={RecordType.invoice}
          member={{
            status: formatMessage({ id: status || 'open', defaultMessage: '-' }),
            ...(invoice_date ? { invoice_date } : {}),
            ...(due_date ? { due_date } : {}),
            rental_code,
            amount: priceFormatter(parseFloat(amount))
          }}
        />
      </Col>
      <If condition={!complained}>
        <Col span={24}>
          <Row>
            <Col span={24}>
              <h5 className="text-black">
                {formatMessage({ id: 'invoice.modal.complaint.title' })}
              </h5>
            </Col>
            <Col span={24}>
              <p className="mb-0">{formatMessage({ id: 'invoice.modal.complaint.description' })}</p>
            </Col>
          </Row>
        </Col>
      </If>
      <Col span={24}>
        <If condition={complained}>
          <Alert
            type="success"
            message={
              <p className="mb-0">{formatMessage({ id: 'invoice.modal.complaint.submitted' })}</p>
            }
          />
        </If>
      </Col>
    </Row>
  )
}

export default InvoiceDetails
